
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const AdType = {
  Banner: 'Banner',
  Tools: 'Tools',
  ToolPage: 'ToolPage',
  BlogPost: 'BlogPost',
  Bottom: 'Bottom',
  All: 'All'
} as const

export type AdType = (typeof AdType)[keyof typeof AdType]


export const ToolStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Pending: 'Pending',
  Published: 'Published'
} as const

export type ToolStatus = (typeof ToolStatus)[keyof typeof ToolStatus]


export const AlternativePageStatus = {
  Draft: 'Draft',
  Published: 'Published'
} as const

export type AlternativePageStatus = (typeof AlternativePageStatus)[keyof typeof AlternativePageStatus]


export const NewsletterSubscriptionStatus = {
  Pending: 'Pending',
  Confirmed: 'Confirmed'
} as const

export type NewsletterSubscriptionStatus = (typeof NewsletterSubscriptionStatus)[keyof typeof NewsletterSubscriptionStatus]


export const NewsletterConsentSource = {
  marketing_cta: 'marketing_cta',
  tool_submit: 'tool_submit'
} as const

export type NewsletterConsentSource = (typeof NewsletterConsentSource)[keyof typeof NewsletterConsentSource]


export const CatalogEntityType = {
  Unknown: 'Unknown',
  Product: 'Product',
  Project: 'Project',
  Infrastructure: 'Infrastructure'
} as const

export type CatalogEntityType = (typeof CatalogEntityType)[keyof typeof CatalogEntityType]


export const DeliveryModel = {
  SaaS: 'SaaS',
  API: 'API',
  Framework: 'Framework',
  Library: 'Library',
  SDK: 'SDK',
  CLI: 'CLI',
  BrowserExtension: 'BrowserExtension',
  Desktop: 'Desktop',
  SelfHosted: 'SelfHosted'
} as const

export type DeliveryModel = (typeof DeliveryModel)[keyof typeof DeliveryModel]


export const RepositoryRole = {
  Unknown: 'Unknown',
  ProductImplementation: 'ProductImplementation',
  OfficialSDK: 'OfficialSDK',
  OfficialClient: 'OfficialClient',
  Integration: 'Integration',
  Plugin: 'Plugin',
  Library: 'Library',
  Example: 'Example',
  Template: 'Template',
  Fork: 'Fork',
  Infrastructure: 'Infrastructure',
  Unrelated: 'Unrelated'
} as const

export type RepositoryRole = (typeof RepositoryRole)[keyof typeof RepositoryRole]


export const LicenseSource = {
  Unknown: 'Unknown',
  RepositoryFile: 'RepositoryFile',
  PackageMetadata: 'PackageMetadata',
  VendorPage: 'VendorPage'
} as const

export type LicenseSource = (typeof LicenseSource)[keyof typeof LicenseSource]


export const QualificationState = {
  Pending: 'Pending',
  NeedsReview: 'NeedsReview',
  Approved: 'Approved',
  Rejected: 'Rejected'
} as const

export type QualificationState = (typeof QualificationState)[keyof typeof QualificationState]


export const RepositoryAction = {
  PublishAsTool: 'PublishAsTool',
  AttachToProduct: 'AttachToProduct',
  UseInGuide: 'UseInGuide',
  FeatureCandidate: 'FeatureCandidate',
  AdjacentInfrastructure: 'AdjacentInfrastructure',
  Historical: 'Historical',
  Reject: 'Reject'
} as const

export type RepositoryAction = (typeof RepositoryAction)[keyof typeof RepositoryAction]


export const ToolTier = {
  Free: 'Free',
  Standard: 'Standard',
  Premium: 'Premium'
} as const

export type ToolTier = (typeof ToolTier)[keyof typeof ToolTier]


export const PostStatus = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Published: 'Published'
} as const

export type PostStatus = (typeof PostStatus)[keyof typeof PostStatus]


export const ReportType = {
  BrokenLink: 'BrokenLink',
  WrongCategory: 'WrongCategory',
  Outdated: 'Outdated',
  Other: 'Other'
} as const

export type ReportType = (typeof ReportType)[keyof typeof ReportType]
